import request from '../../../../shared/lib/request';
import { API } from '../../../../shared/constants';

const getAll = () => request(
  {
    url: API.INTERNO_KIRON,
    method: 'GET',
  });

const create = (content) => request(
  {
    url: API.INTERNO_KIRON,
    method: 'POST',
    data: content,
  });

const put = (content) => request(
  {
    url: `${API.INTERNO_KIRON}/${content.id}`,
    method: 'PUT',
    data: content,
  });

const getById = (id) => request(
  {
    url: `${API.INTERNO_KIRON}/${id}`,
    method: 'GET',
  });

const ResponsabileAreaService = {
  create,
  put,
  getById,
  getAll,
};

export default ResponsabileAreaService;



// WEBPACK FOOTER //
// ./app/shared/services/api/internokiron/index.js